import { useState } from "react";

import { useMachineApi } from "@/sx-layout/components/plotmap/hooks/useMachineApi";
import { Machine } from "@/sx-layout/components/plotmap/models";

export const useMachines = (plotPlanId: number) => {
  const machineApi = useMachineApi(plotPlanId);

  const [machines, setMachines] = useState<Machine[]>([]);

  const refreshMachines = async (): Promise<void> => {
    const response = await machineApi.fetchMachines();
    setMachines(response?.machines ?? []);
  };

  return {
    machines,
    refreshMachines,
  } as const;
};
